export default "__VITE_ASSET__DflEgipX__"